import { render, staticRenderFns } from "./zhusu.vue?vue&type=template&id=6a621412&scoped=true&"
import script from "./zhusu.vue?vue&type=script&lang=js&"
export * from "./zhusu.vue?vue&type=script&lang=js&"
import style0 from "./zhusu.vue?vue&type=style&index=0&id=6a621412&lang=scss&scoped=true&"
import style1 from "./zhusu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a621412",
  null
  
)

export default component.exports